import React from 'react';

const FeaturedSpreadsheetContext = React.createContext({});

export default FeaturedSpreadsheetContext;
